import { render } from "./Chapter6.vue?vue&type=template&id=1b5439fe"
import script from "./Chapter6.vue?vue&type=script&lang=js"
export * from "./Chapter6.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__